{
  "title": "Pass Without Trace",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level abjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (ashes from a burned leaf of mistletoe and a sprig of spruce)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "A veil of shadows and silence radiates from you, masking you and your companions from detection. For the duration, each creature you choose within 30 feet of you (including you) has a +10 bonus to Dexterity (Stealth) checks and can’t be tracked except by magical means. A creature that receives this bonus leaves behind no tracks or other traces of its passage."
  ],
  "spellLists": ["druid", "ranger"]
}
